function pluralRu(count, one, few, many) {
  const value = Math.abs(Number(count))
  const mod10 = value % 10
  const mod100 = value % 100
  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few
  return many
}

export default {
  common: {
    account: 'Аккаунт',
    agents: 'Агенты',
    all: 'Все',
    available: 'Доступно',
    cancel: 'Отмена',
    cloud: 'Облако',
    copy: 'Скопировать',
    current: 'текущая',
    delete: 'Удалить',
    error: 'Ошибка',
    export: 'Экспорт',
    help: 'Помощь',
    home: 'Главная',
    language: 'Язык',
    links: 'Ссылки',
    loading: 'загрузка',
    local: 'Локально',
    login: 'Войти',
    logout: 'Выйти',
    metadata: 'Метаданные',
    more: 'Подробнее',
    name: 'Название',
    never: 'Никогда',
    none: 'нет',
    notes: 'Заметки',
    ok: 'Ок',
    open: 'Открыть',
    password: 'пароль',
    project: 'проект',
    projects: 'Проекты',
    publicLink: 'Публичная ссылка',
    register: 'Регистрация',
    remove: 'Удалить',
    save: 'Сохранить',
    search: 'Поиск',
    settings: 'Настройки',
    subscribe: 'Подписка',
    track: 'трек',
    tracks: 'Треки',
    unknown: 'Неизвестно',
    unknownArtist: 'Неизвестный артист',
    upload: 'Загрузить',
    username: 'имя пользователя'
  },
  errors: {
    genericTitle: 'Что-то пошло не так',
    genericDescription: 'Попробуй ещё раз. Если ошибка повторяется, напиши в поддержку.',
    status: {
      400: 'В данных что-то не так. Проверь форму и попробуй ещё раз.',
      401: 'Нужно войти в аккаунт и попробовать ещё раз.',
      403: 'У тебя нет доступа к этому объекту.',
      404: 'Объект не найден или больше недоступен.',
      409: 'Объект изменился в другом месте. Обнови страницу и попробуй ещё раз.',
      413: 'Файл слишком большой или в облаке закончилось место.',
      429: 'Слишком много попыток. Подожди немного и попробуй ещё раз.',
      500: 'На сервере произошла ошибка. Попробуй позже.',
      502: 'Сервис временно недоступен. Попробуй позже.',
      503: 'Сервис временно недоступен. Попробуй позже.',
      504: 'Запрос выполнялся слишком долго. Попробуй ещё раз.'
    },
    details: {
      network: 'Проверь интернет-соединение и попробуй ещё раз.',
      invalidCredentials: 'E-mail или пароль неверные.',
      invalidToken: 'Ссылка для входа недействительна или истекла.',
      emailRequired: 'Введи e-mail и пароль.',
      invalidEmail: 'Введи корректный e-mail.',
      invalidPassword: 'Пароль должен быть от 3 до 256 символов.',
      userExists: 'Аккаунт с таким e-mail уже существует.',
      storageLimit: 'В облаке закончилось место. Освободи место или обнови подписку.',
      fileTooLarge: 'Этот файл слишком большой для загрузки.',
      trackAlreadyInProject: 'Этот трек уже есть в проекте.',
      trackNotFound: 'Трек не найден или больше недоступен.',
      projectNotFound: 'Проект не найден или больше недоступен.',
      linkNotFound: 'Ссылка не найдена или истекла.',
      fileNotFound: 'Файл трека не найден.'
    },
    context: {
      generic: {
        title: 'Что-то пошло не так',
        description: 'Попробуй ещё раз. Если ошибка повторяется, напиши в поддержку.'
      },
      loadData: {
        title: 'Не удалось загрузить библиотеку',
        description: 'Открылся локальный режим. Проверь соединение и попробуй ещё раз.'
      },
      loadStandaloneTracks: {
        title: 'Не удалось загрузить ещё треки',
        description: 'Проверь соединение и попробуй ещё раз.'
      },
      loadSingleTrack: {
        title: 'Не удалось открыть трек',
        description: 'Трек мог быть удалён или у тебя нет доступа.'
      },
      loadSingleProject: {
        title: 'Не удалось открыть проект',
        description: 'Проект мог быть удалён или у тебя нет доступа.'
      },
      search: {
        title: 'Поиск не сработал',
        description: 'Проверь соединение и попробуй ещё раз.'
      },
      login: {
        title: 'Не удалось войти',
        description: 'Проверь e-mail, пароль или ссылку для входа и попробуй ещё раз.'
      },
      requestPasswordReset: {
        title: 'Не удалось отправить ссылку для входа',
        description: 'Проверь e-mail и попробуй ещё раз.'
      },
      register: {
        title: 'Не удалось создать аккаунт',
        description: 'Проверь введённые данные и попробуй ещё раз.'
      },
      createTrack: {
        title: 'Не удалось сохранить трек',
        description: 'Трек не был сохранён. Проверь соединение и попробуй ещё раз.'
      },
      updateTrack: {
        title: 'Не удалось обновить трек',
        description: 'Изменения не сохранились. Проверь соединение и попробуй ещё раз.'
      },
      deleteTrack: {
        title: 'Не удалось удалить трек',
        description: 'Трек остался в библиотеке. Попробуй ещё раз.'
      },
      createProject: {
        title: 'Не удалось создать проект',
        description: 'Проект не был сохранён. Проверь соединение и попробуй ещё раз.'
      },
      updateProject: {
        title: 'Не удалось обновить проект',
        description: 'Изменения не сохранились. Проверь соединение и попробуй ещё раз.'
      },
      deleteProject: {
        title: 'Не удалось удалить проект',
        description: 'Проект остался в библиотеке. Попробуй ещё раз.'
      },
      reorderProjects: {
        title: 'Не удалось изменить порядок проектов',
        description: 'Новый порядок не сохранился. Попробуй ещё раз.'
      },
      reorderProjectTracks: {
        title: 'Не удалось изменить порядок треков',
        description: 'Новый порядок не сохранился. Попробуй ещё раз.'
      },
      getFile: {
        title: 'Не удалось загрузить файл',
        description: 'Файл может отсутствовать или быть временно недоступен.'
      },
      uploadFile: {
        title: 'Не удалось загрузить файл',
        description: 'Файл не был загружен. Проверь соединение и место в хранилище.'
      },
      deleteCoverImage: {
        title: 'Не удалось удалить обложку',
        description: 'Обложка не была удалена. Попробуй ещё раз.'
      },
      addTrackToProject: {
        title: 'Не удалось добавить трек в проект',
        description: 'Трек остался на прежнем месте. Попробуй ещё раз.'
      },
      moveTrackToProject: {
        title: 'Не удалось переместить трек',
        description: 'Трек остался на прежнем месте. Попробуй ещё раз.'
      },
      removeTrackFromProject: {
        title: 'Не удалось убрать трек из проекта',
        description: 'Трек остался в проекте. Попробуй ещё раз.'
      },
      saveTrackToLocal: {
        title: 'Не удалось сохранить трек локально',
        description: 'Локальная копия не была создана. Попробуй ещё раз.'
      },
      saveTrackToCloud: {
        title: 'Не удалось сохранить трек в облако',
        description: 'Облачная копия не была создана. Проверь соединение и место в хранилище.'
      },
      createLink: {
        title: 'Не удалось создать публичную ссылку',
        description: 'Ссылка не была создана. Попробуй ещё раз.'
      },
      deleteLink: {
        title: 'Не удалось удалить публичную ссылку',
        description: 'Ссылка всё ещё доступна. Попробуй ещё раз.'
      },
      getLink: {
        title: 'Не удалось открыть публичную ссылку',
        description: 'Ссылка могла истечь или быть удалена.'
      }
    }
  },
  time: {
    day: 'день',
    days: 'дней',
    daysAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${pluralRu(count, 'день', 'дня', 'дней')} назад`
    },
    hoursAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${pluralRu(count, 'час', 'часа', 'часов')} назад`
    },
    minutesAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${pluralRu(count, 'минута', 'минуты', 'минут')} назад`
    },
    rightNow: 'только что',
    duration: (ctx) => {
      const minutes = Number(ctx.named('minutes'))
      const seconds = Number(ctx.named('seconds'))
      const minuteLabel = pluralRu(minutes, 'минута', 'минуты', 'минут')
      const secondLabel = pluralRu(seconds, 'секунда', 'секунды', 'секунд')
      if (minutes > 0) return `${minutes} ${minuteLabel} ${seconds} ${secondLabel}`
      return `${seconds} ${secondLabel}`
    }
  },
  topBar: {
    accountFallback: 'Аккаунт',
    storage: 'Хранилище',
    language: 'Язык'
  },
  commandPalette: {
    placeholder: 'Искать треки и проекты...',
    projects: 'Проекты',
    tracks: 'Треки',
    pages: 'Страницы',
    noResults: 'Ничего не найдено',
    quickLinks: 'Быстрый доступ',
    page: {
      home: 'Главная',
      account: 'Аккаунт',
      agents: 'Агенты',
      links: 'Ссылки',
      settings: 'Настройки',
      help: 'Помощь'
    }
  },
  explorer: {
    searchTitle: 'Поиск',
    trackCount: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${pluralRu(count, 'трек', 'трека', 'треков')}`
    }
  },
  emptyState: {
    hello: 'привет',
    addTrack: 'Добавить трек',
    addTrackSubtitle: 'чтобы начать',
    dragDrop: 'Drag-n-drop',
    dragDropSubtitle: 'перетащи файлы для быстрой загрузки',
    switchStorage: 'Переключайся',
    switchStorageSubtitle: 'между облаком и локальным режимом в верхнем меню',
    installAgent: 'Установить агент',
    installAgentSubtitle: 'чтобы загружать файлы автоматически',
    playTrack: 'Запусти трек',
    playTrackSubtitle: 'открой нижний плеер, чтобы использовать эффекты',
    community: 'есть вопросы? заходи в наши сообщества в {discord} и {telegram}.'
  },
  create: {
    createProject: 'Создать проект',
    uploadTrack: 'Загрузить трек',
    newProject: 'Новый проект',
    artist: 'Артист',
    name: 'Название',
    create: 'Создать',
    loading: 'Загрузка...',
    uploadCover: 'Загрузить обложку'
  },
  upload: {
    ariaLabel: 'Загрузить трек',
    uploadTrack: 'Загрузить трек',
    analyzing: 'Анализ...',
    fileAdded: 'Файл "{name}" добавлен',
    fileReadError: 'Ошибка чтения файла.',
    errorWithMessage: 'Ошибка: {message}'
  },
  dragDrop: {
    dropToUpload: 'Отпусти, чтобы загрузить',
    deleteDrop: 'Отпусти здесь, чтобы удалить трек навсегда'
  },
  project: {
    upload: 'Загрузить',
    noTracks: 'Нет треков',
    createdBy: 'создал',
    trackSummary: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${pluralRu(count, 'трек', 'трека', 'треков')}, ${ctx.named('duration')}`
    },
    play: 'Воспроизвести',
    pause: 'Пауза'
  },
  trackItem: {
    more: 'Подробнее',
    copyPublicLink: 'Скопировать публичную ссылку',
    savedLocally: 'Сохранено локально',
    saveLocal: 'Сохранить локально',
    saving: 'Сохранение...',
    saveCloud: 'Сохранить в облако',
    deleteTrack: 'Удалить трек',
    moveUp: 'Переместить выше',
    moveDown: 'Переместить ниже',
    removeFromProject: 'Убрать из {project}',
    moveToProject: 'Переместить в проект',
    currentProject: '(текущий)',
    confirmDelete: 'Точно удалить этот трек?',
    linkCopiedTitle: 'Ссылка скопирована',
    linkCopiedDescription: 'Публичная ссылка скопирована в буфер'
  },
  trackView: {
    created: 'создано {time}',
    tabs: {
      notes: 'Заметки',
      metadata: 'Метаданные'
    },
    notFound: 'трек не найден или недоступен',
    untitled: 'Без названия'
  },
  notes: {
    placeholder: 'Добавь заметки об этом треке...',
    saving: 'Сохранение...',
    saveError: 'Не удалось сохранить заметки. Попробуй ещё раз.'
  },
  metadata: {
    trackOrder: 'Порядок трека',
    artist: 'Артист',
    name: 'Название',
    key: 'Тональность',
    mode: 'Лад',
    deleteTrack: 'Удалить трек',
    saveError: 'Не удалось сохранить метаданные. Попробуй ещё раз.'
  },
  lufs: {
    momentary: 'Мгновенная громкость (LUFS)',
    shortTerm: 'Кратковременная громкость (LUFS)',
    integrated: 'Интегральная громкость (LUFS)'
  },
  effects: {
    pitchshift: 'Питч',
    speed: 'Скорость',
    balance: 'Баланс',
    volume: 'Громкость',
    reverberation: 'Реверберация',
    distortion: 'Дисторшн',
    bitcrush: 'Биткраш',
    saveCurrentEffectsAs: 'Сохранить текущие эффекты как',
    presetName: 'Название',
    add: 'Добавить',
    availablePresets: 'Доступные пресеты',
    tune: 'Тюнинг',
    eq: 'EQ',
    fx: 'FX',
    presets: 'Пресеты',
    center: 'Центр',
    left: 'Лево',
    right: 'Право'
  },
  exportPanel: {
    applyEffects: 'Применить текущие эффекты',
    applyEffectsSubtitle: 'Экспортировать трек с текущими эффектами',
    exportWav: 'Экспорт в WAV',
    exportMp3: 'Экспорт в MP3',
    exporting: 'Экспорт...',
    exportAsNewTrack: 'Экспортировать как новый трек',
    creatingTrack: 'Создание трека...',
    downloadOriginal: 'Скачать оригинал',
    originalUnavailable: 'Оригинальный файл недоступен.',
    downloadOriginalFailed: 'Не удалось скачать оригинальный файл.',
    exportAudioFailed: 'Не удалось экспортировать аудио трека.',
    waveformFailed: 'Не удалось создать waveform.',
    createTrackFailed: 'Не удалось создать экспортированный трек.',
    createTrackAlert: 'Не удалось создать экспортированный трек: {message}',
    exportedSuffix: ' (экспорт)',
    copySuffix: ' (копия)'
  },
  publicLink: {
    copy: 'Скопировать',
    open: 'Открыть',
    linkCopiedTitle: 'Ссылка скопирована',
    linkCopiedDescription: 'Публичная ссылка скопирована в буфер'
  },
  settings: {
    tabs: {
      settings: 'Настройки',
      account: 'Аккаунт',
      links: 'Ссылки',
      agents: 'Агенты'
    },
    display: 'Отображение',
    language: 'Язык',
    showBpm: 'Показывать BPM в треке',
    showBpmSubtitle: 'Показывать темп каждого трека в списке',
    showLufs: 'Показывать LUFS в треке',
    showLufsSubtitle: 'Показывать громкость каждого трека в списке',
    showKey: 'Показывать тональность в треке',
    showKeySubtitle: 'Показывать тональность и лад каждого трека в списке',
    playback: 'Воспроизведение',
    liveLoudness: 'Live loudness metering',
    liveLoudnessSubtitle: 'Показывать live loudness meter в плеере',
    persistEffects: 'Сохранять эффекты для всех треков',
    persistEffectsSubtitle: 'Оставлять применённые эффекты при переключении трека',
    keyboardShortcuts: 'Горячие клавиши',
    search: 'Поиск',
    pressShortcut: 'Нажми нужную комбинацию клавиш',
    storage: 'Хранилище',
    resetPresetsInfo: 'Сбросить все пресеты в этом браузере',
    resetPresets: 'Сбросить пресеты',
    resetAllWarning: 'Внимание! Кнопка ниже удалит все данные в локальном хранилище!',
    resetAllData: 'Сбросить локальное хранилище и удалить все треки и проекты',
    loadingAccount: 'Загрузка аккаунта...',
    loadingLinks: 'Загрузка ссылок...',
    loadingAgents: 'Загрузка агентов...',
    authPrompt: 'Войди или зарегистрируйся, чтобы использовать этот раздел.',
    loginRegister: 'Войти или зарегистрироваться',
    pageTitle: {
      settings: 'настройки',
      account: 'настройки аккаунта',
      links: 'публичные ссылки',
      agents: 'агенты'
    },
    presetsCleared: 'Хранилище пресетов очищено',
    localDataDeleted: 'Все локальные данные удалены',
    linkCopied: 'Ссылка скопирована',
    linkCopyFailed: 'Не удалось скопировать ссылку'
  },
  account: {
    hello: 'Привет, {name}.',
    subscriptionStatus: 'Твоя подписка сейчас {status}',
    noSubscription: 'Активной подписки нет.',
    manageSubscription: 'Управлять подпиской и оплатой',
    subscribeCloud: 'Подписаться для облака',
    changeUsername: 'Изменить имя',
    changePassword: 'Изменить пароль',
    saveUsername: 'Сохранить имя',
    savePassword: 'Сохранить пароль',
    newPassword: 'новый пароль',
    confirmPassword: 'подтвердить пароль',
    usernamePlaceholder: 'твоё имя пользователя',
    storageUsage: 'Использование хранилища',
    baseStorage: 'Базовое хранилище',
    subscriptionStorage: 'Хранилище подписки',
    used: 'Использовано',
    available: 'Доступно',
    deletedFilesNotice: 'Если ты недавно удалял файлы, они всё ещё могут попадать в эти метрики. Это обновится в течение нескольких часов.',
    accountId: 'id аккаунта',
    currentPeriodEnds: (ctx) => `текущий оплаченный период закончится через ${ctx.named('count')} ${ctx.named('label')}`,
    accessEnds: (ctx) => `доступ по подписке закончится через ${ctx.named('count')} ${ctx.named('label')}`,
    lastPaymentEnded: (ctx) => `последний оплаченный период закончился ${ctx.named('date')}`,
    previousBillingDate: 'предыдущая дата оплаты',
    billingPortalError: 'Ошибка биллинга',
    billingPortalFailed: 'Не удалось открыть портал оплаты.',
    loginRequiredUpdate: 'Нужно войти, чтобы обновить профиль.',
    usernameEmpty: 'Имя пользователя не может быть пустым.',
    usernameUnchanged: 'Имя пользователя не изменилось.',
    usernameUpdated: 'Имя пользователя обновлено',
    usernameUpdateFailed: 'Не удалось обновить имя. Попробуй ещё раз.',
    passwordEmpty: 'Пароль не может быть пустым.',
    passwordsMismatch: 'Пароли не совпадают.',
    passwordUpdated: 'Пароль обновлён',
    passwordUpdateFailed: 'Не удалось обновить пароль. Попробуй ещё раз.'
  },
  links: {
    title: 'Публичные ссылки',
    description: 'Все твои публичные ссылки собраны здесь. Любой, у кого есть доступ к ним, может слушать проект или трек.',
    cloudOnly: 'Публичные ссылки доступны только в облачном режиме. Переключись на Cloud storage, чтобы создавать и управлять ссылками.',
    noLinks: 'Публичных ссылок нет',
    createFirst: 'Создай первую публичную ссылку, чтобы начать делиться.',
    confirmDelete: 'Точно удалить эту ссылку?',
    notFoundTitle: 'Ссылка не найдена или истекла',
    notFoundDescription: 'Ссылка недействительна или срок её действия истёк.',
    unknownUser: 'неизвестно'
  },
  agents: {
    authorizeTitle: 'Авторизовать агент',
    authorizeDescription: 'Разрешить этому агенту подключиться к твоему аккаунту.',
    loginToAuthorize: 'Войди, чтобы авторизовать агент.',
    wantsConnect: 'Этот агент хочет подключиться к твоему аккаунту, чтобы автоматически загружать аудиофайлы.',
    permissionUpload: 'Загружать треки',
    permissionMetadata: 'Создавать метаданные треков',
    authorize: 'Авторизовать',
    cancel: 'Отмена',
    authorizedTitle: 'Агент авторизован',
    authorizedDescription: 'Теперь можно закрыть это окно и вернуться в приложение агента.',
    desktopTitle: 'Desktop Agent',
    installDescription: 'Установи demoparty agent на PC или Mac, чтобы автоматически загружать свежие рендеры.',
    warningLabel: 'ВНИМАНИЕ: ',
    alphaWarning: 'агент в alpha-версии и может работать нестабильно.',
    downloadMacApple: 'Скачать для Mac с Apple Silicon',
    downloadMacIntel: 'Скачать для Mac с Intel',
    downloadWindows: 'Скачать для Windows x64',
    signingNotice: 'Эти сборки не подписаны цифровой подписью, потому что проект всё ещё в разработке. Предупреждения безопасности при запуске ожидаемы. Подписанные сборки появятся позже.',
    activeTitle: 'Активные агенты',
    connectedDescription: 'Агенты, подключённые к твоему аккаунту.',
    loginToManage: 'Войди, чтобы управлять агентами.',
    noAgents: 'Подключённых агентов пока нет.',
    lastUsed: 'Последний запуск',
    revoke: 'Отозвать',
    remove: 'Удалить',
    confirmRemove: 'Точно удалить этот агент?',
    authorizeFailed: 'Не удалось авторизовать агент. Попробуй ещё раз.'
  },
  login: {
    intro: 'Войди, если хочешь использовать облачные возможности и преимущества подписки. Иначе сервис можно бесплатно использовать локально.',
    subscriptionBenefits: 'преимущества подписки',
    login: 'Вход',
    register: 'Регистрация',
    forgot: 'Я забыл пароль',
    email: 'e-mail',
    password: 'пароль',
    repeatPassword: 'повтори пароль',
    or: 'или',
    google: 'Войти через Google',
    apple: 'Войти через Apple',
    resetPassword: 'Сбросить пароль',
    resetDescription: 'Мы отправим ссылку для входа, чтобы ты смог задать новый пароль.',
    sendResetLink: 'Отправить ссылку',
    invalidToken: 'Токен недействителен или истёк',
    enterEmail: 'Введи e-mail',
    resetSent: 'Если аккаунт существует, мы отправили ссылку для входа на e-mail.',
    resetFailed: 'Не удалось отправить ссылку. Попробуй ещё раз.'
  },
  googleCallback: {
    wait: 'Подожди, выполняем вход...'
  },
  subscribe: {
    cloudRequiredTitle: 'Нужно облачное хранилище',
    cloudRequiredMessage: 'Эта функция доступна только с облачным хранилищем и активной подпиской.',
    title: 'Начни локально. Обновись для авто-загрузки.',
    description: 'Облако даёт одну синхронизированную библиотеку на всех устройствах.',
    localFree: 'Приложение можно бесплатно использовать в локальном режиме.',
    cloudIncludes: 'В облако входит',
    featureLibrary: 'Одна синхронизированная библиотека для web и iPhone',
    featureAgent: 'Desktop agent для авто-загрузки свежих рендеров',
    featureStorage: '100 GB облачного хранилища для треков',
    featureLinks: 'Постоянные публичные ссылки для треков и проектов',
    featureTools: 'Все локальные инструменты анализа, эффектов и экспорта',
    monthly: 'Месячная',
    monthlyDescription: 'Cloud sync, отмена в любой момент',
    yearly: 'Годовая',
    yearlyDescription: 'Лучшее значение для Cloud sync',
    saveTen: 'Скидка 10%',
    perMonth: '/месяц',
    billedMonthly: 'Оплата ежемесячно',
    billedYearly: '$53.89 в год',
    openingCheckout: 'Открываем checkout...',
    subscribePlan: 'Подписаться: {plan}',
    registerSubscribe: 'Зарегистрироваться и подписаться',
    securePayment: 'Безопасная оплата через Polar. Отмена в любой момент в настройках аккаунта.',
    customPlan: 'Нужен кастомный план или есть вопросы? Напиши нам на',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    refund: 'Refund Policy',
    checkoutFailed: 'Не удалось создать checkout. Попробуй ещё раз.'
  },
  thanks: {
    title: 'Спасибо за подписку!',
    description: 'Теперь можно использовать облачное хранилище. Управлять подпиской можно на странице аккаунта.',
    startWorking: 'Начать работу',
    communities: 'Наши сообщества',
    support: 'Если будут проблемы, напиши нам на {email} или через ссылки на сообщества выше.'
  },
  help: {
    title: 'Помощь',
    intro: 'demoparty — рабочее пространство для незаконченной музыки и work-in-progress проектов. Здесь можно хранить демки, применять эффекты, редактировать теги и отслеживать технические метаданные. Локальное использование полностью бесплатное.',
    uploadTitle: 'Загрузка',
    uploadText: 'Трек можно добавить кнопкой Add на главной странице. Во время загрузки система автоматически определяет тональность, BPM и LUFS. После завершения загрузки появится уведомление.',
    storageTitle: 'Хранилище',
    storageText: 'В demoparty есть два варианта хранения: локальный и облачный.',
    localStorageText: 'Локальное хранилище хранит все данные только на твоём устройстве. Треки и проекты доступны только в браузере, куда они были загружены. Для хранения используется IndexedDB. Регистрация не нужна, данные никуда не отправляются.',
    cloudStorageText: 'Облачное хранилище хранит данные на серверах demoparty. Треки доступны откуда угодно и в любое время. Нужны регистрация и активная подписка.',
    agentsTitle: 'Агенты',
    agentsText: 'В облачном режиме можно установить desktop agent. Он автоматически загружает новые рендеры в облако.',
    publicLinksTitle: 'Публичные ссылки',
    publicLinksText: 'Пользователи облака могут создавать публичные ссылки на треки и проекты. На странице проекта нажми кнопку ссылки. Для треков используй такой же значок в dropdown-меню трека. Все созданные ссылки управляются из настроек.',
    exportTitle: 'Экспорт',
    exportText: 'Треки можно экспортировать со всеми применёнными эффектами. Открой страницу трека и выбери Export. Можно скачать оригинальный файл или экспортировать MP3/WAV.',
    supportTitle: 'Поддержка',
    supportText: "По вопросам облака и подписок demoparty пиши на support{'@'}demoparty.app.",
    attributionsTitle: 'Attributions',
    attributionsText: 'Следующие библиотеки сделали этот проект возможным. Спасибо их разработчикам.'
  },
  cover: {
    upload: 'Загрузить обложку',
    change: 'Изменить обложку',
    delete: 'Удалить обложку',
    loading: 'Загрузка...',
    selectImage: 'Выбери файл изображения',
    uploadError: 'Ошибка загрузки обложки'
  }
}
